import { useState, useEffect } from "react";

import SlotEventCard from "./SlotEventCard";

import { hourNumberToTime } from "../utils/utils";
import { SLOT_HEIGHT } from "../js/constants";

import moment from "moment";

export default ({ day, time, minute, events, onClickEvent, onClickSlot }) => {
  const [slotEvents, setSlotEvents] = useState([]);

  const buildEvents = () => {
    const evs = events.filter((event) => {
      return (
        event.visible &&
        event.timeStart !== -1 &&
        event.date === day.format("YYYY-MM-DD") &&
        hourNumberToTime(time) ===
          moment(event.timeStart, "HH:mm:ss").format("HH") &&
        moment(event.timeStart, "HH:mm:ss").format("mm") === minute
      );
    });
    setSlotEvents(evs);
  };

  useEffect(() => {
    if (day && events) {
      buildEvents();
    }
  }, [events]);

  return (
    <div
      className="calendar-event-slot clickable-slot"
      style={{ height: SLOT_HEIGHT }}
      onClick={() =>
        onClickSlot(day.format("YYYY-MM-DD"), time + ":" + minute + ":00")
      }
    >
      {slotEvents.map((event, index) => {
        return (
          <SlotEventCard
            key={index}
            event={event}
            numEvents={slotEvents.length}
            numEvent={index}
            onClickEvent={onClickEvent}
          />
        );
      })}
    </div>
  );
};
